import { useMemo } from 'react'
import { Table as AntTable } from 'antd'
import { ColumnType, TableProps } from 'antd/es/table'

export type TTable = Omit<TableProps, 'dataSource'> & {
  data: TableProps['dataSource']
}

export type TColumn = ColumnType<{}>

export function Table({ data, columns = [], ...otherProps }: TTable) {
  const newColumns = useMemo(() => {
    return columns.map((c) => ({ dataIndex: c.key, ...c }))
  }, [columns])

  return <AntTable columns={newColumns} dataSource={data} {...otherProps} />
}
